<template>
  <div>
    <div class="side_btns_bar">
      <div class="item" @click="openChat">
        <i class="iconfont icon-icon-06"></i>
      </div>
      <div class="item" @click="showService = true" v-if="show==true">
        <i class="iconfont icon-icon-07"></i>
      </div>
      <div class="item" @click="showPublicCode = true">
        <i class="iconfont icon-icon-083"></i>
      </div>
    </div>

    <!-- 弹框-联系客服 -->
    <van-popup v-model:show="showService" position="right" :style="{ width: '100%', height: '100%' }">
      <van-nav-bar z-index="10" left-arrow title="联系客服" @click-left="showService = false"></van-nav-bar>
      <div class="service_list">
        <div class="row" v-if="phone">
            <i class="iconfont icon-icon-08 red"></i>
            <span>{{phone}}</span>
        </div>
        <div class="row" v-if="email">
            <i class="iconfont icon-icon-09 orange"></i>
            <a :href="`mailto:${ email }`">{{ email }}</a>
        </div>
        <div class="row" v-if="qq">
            <i class="iconfont icon-111_huaban1 blue"></i>
            <a target="_blank" :href="`http://wpa.qq.com/msgrd?v=3&uin=${ qq }&site=qq&menu=yes`">{{ qq }}</a>
        </div>
        <div class="row" v-if="wechat">
            <i class="iconfont icon-111-02 green"></i>
            <div class="wechat">
                <span>客服微信</span>
                <img :src="wechat" />
            </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model:show="showPublicCode" style="border-radius:4px;">
      <div class="public_code">
        <img :src="require('assets/img/public_code.jpg')" />
        <span>添加公众号领取免费会员</span>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import { list_configures } from "api/operation/configure.js"
  export default {
    data() {
      return {
        phone: '',
        qq: '',
        email: '',
        wechat: '',
        show: false,
        showService: false,
        showPublicCode: false
      }
    },
    mounted() {
      let that = this
      list_configures().then((res) => {
        if(res.data.connection != undefined){
          that.email = res.data.connection.email
          that.phone = res.data.connection.phone
          that.qq = res.data.connection.qq
          that.wechat = res.data.connection.weixin
          if((that.email + that.phone + that.qq + that.wechat) != 'null'){
            that.show = true
          }
        }

      })
    },
    methods: {
      openChat() {
        window.qimoChatClick();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .side_btns_bar {
    position:fixed;
    right:10px;
    bottom:100px;
    z-index:1;
    .item {
      border-radius:50%;
      color:#fff;
      background:#009bd7;
      width: 36px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      margin-bottom:15px;
      -webkit-box-shadow: 0 0 5px rgba(0,0,0,0.2);
      i {
        font-size:20px;
      }
    }
  }

  .service_list {
      padding:15px;
      .row {
          margin-top:10px;
          display:flex;
          > i {
              font-size:30px;
              margin-right:10px;
              &.red {
                  color:#f15a51;
              }
              &.orange {
                  color:#ff9900;
              }
              &.blue {
                  color:#18acfc;
              }
              &.green {
                  color:#00bb29;
              }
          }
          > span, > a {
              display:flex;
              align-items: center;
          }
          .wechat {
              padding-top:10px;
              > span {
                  display:block;
                  margin-bottom:10px;
              }
              > img {
                  max-width: 100%;
                  max-height: 100%;
              }
          }
          &:first-child {
              margin-top:0;
          }
      }
  }
  .public_code {
    padding:15px;
    text-align: center;
    > img {
      display:block;
      width:200px;
      margin: 0 auto;
    }
    > span {
      color:#999;
    }
  }
</style>
